import React from 'react';
import macbook from '../../images/Capture3.PNG'

const MacOs = () => {
    return (
        <div 
        data-aos="zoom-in"
        data-aos-duration="3000"
        className="bg-gray-300 ">
           <h1 className="text-4xl font-semibold text-red-500">Purchase Mac Book</h1>
           <div className="grid lg:grid-cols-3 px-5 mt-3">
               <div >
                   <img className="px-3" src={macbook} alt="" />
               </div>
               <div>
                   <img className="px-3" src="https://i.ibb.co/LNH9WfT/mac-1.png" alt="" />
               </div>
               <div>
                   <img className="px-3" src="https://i.ibb.co/Ss9kC4R/mac-2.png" alt="" />
               </div>
           </div>

           <div className="mt-10">
               
               <p className="text-justify text-xl px-20  mb-5"> A full-stack single-page purchasing web app. Users can buy electronics parts and see their purchase records. There is a cupon code for 10% discount.This is a part ofe-commerce shop </p>
               
               <button className="px-2 py-1 bg-gray-400 ">JavaScript</button> 
        <button className="px-2 py-1 bg-gray-400 mx-1">Bootstrap</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Cupon System</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">Express.js</button>
        <button className="px-2 py-1 bg-gray-400 mx-1">MongoDB</button>
           </div>

           <div className="mt-5 pb-10"> 
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://mac-os-1tb.netlify.app/">Live Preview</a> </button>
               <button className="bg-gray-600 rounded px-5 py-2  text-white text-xl mx-2"> <a href="https://github.com/Joy10311/Top-Devolopers"> Code</a> </button>
              
           </div>
        </div>
    );
};

export default MacOs;